import {BasicListReducerStateType, TotalsListReducerStateType} from "../BasicReducerState";
import {Nullable} from "../../models/common/Nullable";
import {ProjectAppendix} from "../../models/projects/ProjectAppendix";
import {
    errorFetchingRequestState,
    getInitialRequestState,
    RequestState,
    startFetchingRequestState,
    successFetchingRequestState
} from "../../models/common/RequestState";
import {
    CREATE_PROJECT_APPENDIX,
    CREATE_PROJECT_APPENDIX_ERROR,
    CREATE_PROJECT_APPENDIX_SUCCESS,
    DELETE_PROJECT_APPENDIX,
    DELETE_PROJECT_APPENDIX_ERROR,
    DELETE_PROJECT_APPENDIX_SUCCESS,
    FETCH_NEXT_PROJECT_APPENDIX_NUMBER,
    FETCH_NEXT_PROJECT_APPENDIX_NUMBER_ERROR,
    FETCH_NEXT_PROJECT_APPENDIX_NUMBER_SUCCESS,
    FETCH_PROJECT_APPENDIX,
    FETCH_PROJECT_APPENDIX_BY_ID, FETCH_PROJECT_APPENDIX_BY_ID_ERROR,
    FETCH_PROJECT_APPENDIX_BY_ID_SUCCESS,
    FETCH_PROJECT_APPENDIX_ERROR,
    FETCH_PROJECT_APPENDIX_SUCCESS,
    ProjectAppendixViewActionTypes,
    UPDATE_PROJECT_APPENDIX,
    UPDATE_PROJECT_APPENDIX_ERROR,
    UPDATE_PROJECT_APPENDIX_SUCCESS
} from "../../actions/projects/ProjectAppendixActions";
import {getInitialViewSettings, UserViewSettingsProp} from "../../models/common/ViewSettings";
import {ProjectAppendixModule} from "../../models/projects/ProjectAppendixModule";
import {ProjectReportBudget, projectReportBudgetBase} from "../../models/reporting/ProjectReportBudget";

export interface ProjectAppendixState extends TotalsListReducerStateType< Nullable< ProjectAppendix[] >, ProjectReportBudget >,
    UserViewSettingsProp
{
    mutatingRequest: RequestState
    nextAppendixNumber: { [ key: number ]: number }
    nextAppendixNumberRequest: RequestState
    currentDetail: {
        entry: Nullable< ProjectAppendix >
        request: RequestState
    }
}

const initialState: ProjectAppendixState = {
    totalEntries: 0,
    totals: projectReportBudgetBase,
    userViewSettings: getInitialViewSettings( ProjectAppendixModule.identifier ),
    entries: {
        current: null,
        request: getInitialRequestState()
    },
    currentDetail: {
        entry: null,
        request: getInitialRequestState()
    },
    nextAppendixNumber: {},
    nextAppendixNumberRequest: getInitialRequestState(),
    mutatingRequest: getInitialRequestState()
}

export function ProjectAppendixReducer(
    state: ProjectAppendixState = initialState,
    action: ProjectAppendixViewActionTypes
) {
    switch( action.type ) {
        case FETCH_PROJECT_APPENDIX:
            return {
                ...state,
                userViewSettings: action.userViewSettings,
                totalEntries: 0,
                entries: {
                    current: null,
                    request: startFetchingRequestState()
                }
            };
        case FETCH_PROJECT_APPENDIX_SUCCESS:
           return {
               ...state,
               totals: action.payload.totals,
               totalEntries: action.payload.totalEntries,
               entries: {
                   current: action.payload.entries,
                   request: successFetchingRequestState()
               }
           };
        case FETCH_PROJECT_APPENDIX_ERROR:
            return {
                ...state,
                entries: {
                    ...state.entries,
                    current: [],
                    request: errorFetchingRequestState( action.error )
                }
            };
        case FETCH_PROJECT_APPENDIX_BY_ID:
            return {
                ...state,
                currentDetail: {
                    entry: null,
                    request: startFetchingRequestState()
                }
            };
        case FETCH_PROJECT_APPENDIX_BY_ID_SUCCESS:
            return {
                ...state,
                currentDetail: {
                    entry: action.payload,
                    request: successFetchingRequestState()
                }
            };
        case FETCH_PROJECT_APPENDIX_BY_ID_ERROR:
            return {
                ...state,
                currentDetail: {
                    ...state.currentDetail,
                    request: errorFetchingRequestState( action.error )
                }
            };
        case CREATE_PROJECT_APPENDIX:
        case UPDATE_PROJECT_APPENDIX:
        case DELETE_PROJECT_APPENDIX:
            return {
                ...state,
                mutatingRequest: startFetchingRequestState()
            };
        case CREATE_PROJECT_APPENDIX_SUCCESS:
        case UPDATE_PROJECT_APPENDIX_SUCCESS:
        case DELETE_PROJECT_APPENDIX_SUCCESS:
            return {
                ...state,
                mutatingRequest: successFetchingRequestState()
            };
        case CREATE_PROJECT_APPENDIX_ERROR:
        case UPDATE_PROJECT_APPENDIX_ERROR:
        case DELETE_PROJECT_APPENDIX_ERROR:
            return {
                ...state,
                mutatingRequest: errorFetchingRequestState( action.error )
            };

        case FETCH_NEXT_PROJECT_APPENDIX_NUMBER:
            return {
                ...state,
                nextAppendixNumberRequest: startFetchingRequestState(),
                nextAppendixNumber: { [ action.projectId.rawValue ]: 0 },
            };
        case FETCH_NEXT_PROJECT_APPENDIX_NUMBER_SUCCESS:
            return {
                ...state,
                nextAppendixNumber: { [ action.projectId.rawValue ]: action.payload },
                nextAppendixNumberRequest: successFetchingRequestState()
            };
        case FETCH_NEXT_PROJECT_APPENDIX_NUMBER_ERROR:
            return {
                ...state,
                nextAppendixNumberRequest: errorFetchingRequestState( action.error )
            };
        default:
            return state;
    }
}